// Available customer fields for mapping
export const CUSTOMER_FIELD_MAPPINGS = [
    {
        field: "firstName",
        label: "First Name",
        required: true,
        type: "string",
        description: "Customer's first name (required)",
    },
    {
        field: "lastName",
        label: "Last Name",
        required: true,
        type: "string",
        description: "Customer's last name (required)",
    },
    {
        field: "email",
        label: "Email",
        required: false,
        type: "email",
        description: "Customer's email address",
    },
    {
        field: "phone",
        label: "Phone",
        required: false,
        type: "phone",
        description: "Customer's phone number",
    },
    {
        field: "dateOfBirth",
        label: "Date of Birth",
        required: false,
        type: "date",
        description: "Customer's date of birth (YYYY-MM-DD format)",
    },
    {
        field: "gender",
        label: "Gender",
        required: false,
        type: "enum",
        enumValues: ["MALE", "FEMALE", "OTHER", "PREFER_NOT_TO_SAY"],
        description: "Customer's gender",
    },
    {
        field: "idType",
        label: "ID Type",
        required: false,
        type: "enum",
        enumValues: ["CPF", "RG", "PASSPORT"],
        description: "Type of identification document",
    },
    {
        field: "idNumber",
        label: "ID Number",
        required: false,
        type: "string",
        description: "Identification document number",
    },
    {
        field: "address",
        label: "Address",
        required: false,
        type: "string",
        description: "Customer's street address",
    },
    {
        field: "addressNumber",
        label: "Address Number",
        required: false,
        type: "string",
        description: "Street address number",
    },
    {
        field: "address2",
        label: "Address Line 2",
        required: false,
        type: "string",
        description: "Apartment, suite, or additional address information",
    },
    {
        field: "city",
        label: "City",
        required: false,
        type: "string",
        description: "Customer's city",
    },
    {
        field: "state",
        label: "State",
        required: false,
        type: "string",
        description: "Customer's state or province",
    },
    {
        field: "postalCode",
        label: "Postal Code",
        required: false,
        type: "string",
        description: "Customer's postal or ZIP code",
    },
    {
        field: "country",
        label: "Country",
        required: false,
        type: "string",
        description: "Customer's country",
    },
    {
        field: "profession",
        label: "Profession",
        required: false,
        type: "string",
        description: "Customer's profession or occupation",
    },
    {
        field: "emergencyContactName",
        label: "Emergency Contact Name",
        required: false,
        type: "string",
        description: "Name of emergency contact person",
    },
    {
        field: "emergencyContactPhone",
        label: "Emergency Contact Phone",
        required: false,
        type: "phone",
        description: "Phone number of emergency contact",
    },
    {
        field: "notes",
        label: "Notes",
        required: false,
        type: "string",
        description: "Additional notes about the customer",
    },
];
// Helper function to get field mapping by field name
export const getCustomerFieldMapping = (field) => {
    return CUSTOMER_FIELD_MAPPINGS.find((mapping) => mapping.field === field);
};
// Helper function to get required fields
export const getRequiredCustomerFields = () => {
    return CUSTOMER_FIELD_MAPPINGS.filter((mapping) => mapping.required);
};
// Helper function to get optional fields
export const getOptionalCustomerFields = () => {
    return CUSTOMER_FIELD_MAPPINGS.filter((mapping) => !mapping.required);
};
// Canonical column order for customer CSV export.
// Derived from CUSTOMER_FIELD_MAPPINGS so an exported file uses the exact
// columns the importer accepts — guarantees round-trippability.
export const CUSTOMER_EXPORT_FIELDS = CUSTOMER_FIELD_MAPPINGS.map((mapping) => mapping.field);
//# sourceMappingURL=Import.js.map